import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";  // to get the slug from the URL
import useFetch from './ApiClient/GetApi'; // assuming you have a fetch utility

function PageComponent() {
  const { slug } = useParams();  // Get the slug from URL params
  const { apiData, isLoading, error } = useFetch(`/user/getPageDetails/${slug}`);  // Fetch data based on the slug
  const [pageData, setPageData] = useState(null);
  
  useEffect(() => {
    if (apiData?.data?.pageDetails) {
      setPageData(apiData.data.pageDetails); // Store the entire page details
    }
  }, [apiData]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }
  console.log(pageData)

  // Render the page content dynamically based on the fetched data
  return (
   <div className="home-container">
     <main>
      {pageData ? (
        <div>
          <h1>{pageData.name}</h1> {/* Display page name */}
          <div dangerouslySetInnerHTML={{ __html: pageData.content }} /> {/* Render content (HTML) */}
        </div>
      ) : (
        <div>No page data found</div>
      )}
      </main>
    </div>
  );
}

export default PageComponent;
